import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import React from 'react';
import Text from '@magalu/stereo-ui/atoms/Text';
import Box from '@magalu/stereo-ui/atoms/Box';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import Input from '@magalu/stereo-ui/atoms/Input';
import Button from '@magalu/stereo-ui/atoms/Button';
import HiddenLabel from '@magalu/stereo-ui/molecules/HiddenLabel';
import { usePublisher } from '@magalu/mixer-publisher';
import { useQuestionInputValidation, useUserData } from '../../../hooks';
import { ButtonFloatContainer, DialogContainer as Dialog } from './QuestionFloatForm.styles';
var _require = require('prop-types'),
  shape = _require.shape,
  string = _require.string;
var QuestionFloatForm = function QuestionFloatForm(_ref) {
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showFloatModal = _React$useState2[0],
    setShowFloatModal = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    chars = _React$useState4[0],
    setChars = _React$useState4[1];
  var _React$useState5 = React.useState({}),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    userData = _React$useState6[0],
    setUserData = _React$useState6[1];
  var emptyTitle = staticProps.emptyTitle,
    buttonText = staticProps.buttonText;
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish,
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var getUserData = React.useCallback(_asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
    var data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return useUserData({
            structure: structure
          });
        case 2:
          data = _context.sent;
          setUserData(data);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), []);
  var handleEdit = function handleEdit() {
    return setShowFloatModal(true);
  };
  var handleClean = function handleClean() {
    return setChars('');
  };
  React.useEffect(function () {
    subscribe('question-confirm:clean', handleClean);
    subscribe('question:edit', handleEdit);
    getUserData();
    return function () {
      unsubscribe('question-confirm:clean', handleClean);
      unsubscribe('question:edit', handleEdit);
    };
  }, [getUserData]);
  var onClickSubmit = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(e) {
      var _yield$useUserData, id, isLogged;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            setShowFloatModal(false);
            _context2.next = 4;
            return useUserData({
              structure: structure
            });
          case 4:
            _yield$useUserData = _context2.sent;
            id = _yield$useUserData.id;
            isLogged = _yield$useUserData.isLogged;
            publish('question:form:submit', {
              event: e,
              label: buttonText.authenticated,
              logged: isLogged,
              userId: id
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onClickSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var _useQuestionInputVali = useQuestionInputValidation(chars),
    message = _useQuestionInputVali.message,
    textColor = _useQuestionInputVali.textColor,
    inputValid = _useQuestionInputVali.valid;
  return React.createElement(React.Fragment, null, showFloatModal && React.createElement(Dialog, {
    type: "dialog",
    showClose: true,
    onClickOutside: function onClickOutside() {
      setShowFloatModal(false);
    },
    portal: true
  }, React.createElement("form", {
    onSubmit: onClickSubmit
  }, React.createElement(Box, {
    mx: 2,
    mb: 2
  }, React.createElement(Text, {
    fontSize: [1, 1, 2, 2],
    color: "text.dark",
    fontWeight: "medium",
    my: 3
  }, emptyTitle), React.createElement(HiddenLabel, {
    title: "digite sua pergunta abaixo",
    htmlFor: "question-input"
  }), React.createElement(Input, {
    "data-testid": "publish-new-question-float",
    id: "question-input",
    onChange: function onChange(e) {
      setChars(e.target.value);
      publish('question:write', e);
    },
    hasError: chars.length > 0 && !inputValid,
    value: chars,
    placeholder: "Escreva aqui sua d\xFAvida...",
    multiline: true
  })), React.createElement(Text, {
    fontSize: [0, 0, 1, 1],
    color: textColor,
    mb: 4,
    mx: 2
  }, message), React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "center",
    mx: 3,
    mb: 2,
    gap: "30%"
  }, React.createElement(Box, null, React.createElement(Text, {
    fontSize: [0, 0, 1, 1],
    color: "text.primary",
    center: true,
    onClick: function onClick() {
      return setShowFloatModal(false);
    }
  }, "Cancelar")), React.createElement(Button, {
    "data-testid": "button-submit-question",
    full: true,
    centered: true,
    disabled: !inputValid
  }, React.createElement(Text, {
    fontWeight: "medium",
    color: "text.white"
  }, buttonText.authenticated))))), React.createElement(ButtonFloatContainer, {
    visible: true
  }, React.createElement(Button, {
    variation: "outline",
    "data-testid": "button-write-question",
    full: true,
    centered: true,
    onClick: _asyncToGenerator(_regeneratorRuntime().mark(function _callee3() {
      var _yield$useUserData2, isLogged;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            publish(buttonText.event, {
              label: userData.isLogged ? buttonText.authenticated : buttonText.unauthenticated,
              logged: userData.isLogged,
              userId: userData.id
            });
            _context3.next = 3;
            return useUserData({
              structure: structure
            });
          case 3:
            _yield$useUserData2 = _context3.sent;
            isLogged = _yield$useUserData2.isLogged;
            setShowFloatModal(!!isLogged);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })),
    disabled: false
  }, React.createElement(Text, {
    fontWeight: "medium",
    color: "text.primary"
  }, userData.isLogged ? buttonText.authenticated : buttonText.unauthenticated))));
};
process.env.NODE_ENV !== "production" ? QuestionFloatForm.propTypes = {
  "static": shape({
    buttonText: shape({
      authenticated: string,
      unauthenticated: string
    }).isRequired
  }).isRequired,
  structure: shape({}).isRequired
} : void 0;
QuestionFloatForm.defaultProps = {};
export default QuestionFloatForm;